export const BRAND = {
  name: 'Guardian Artificial Lawns',
  short: 'Guardian',
  phone: '01634 557852',
  phoneTel: '+441634557852',
  email: 'info@guardianartificiallawns.co.uk',
  domain: 'www.guardianartificiallawns.co.uk',
  area: 'London & surrounding counties',
  address: 'London & South East England',
  hours: 'Monday — Friday   07:30 — 17:30',
  logo: '/guardian-logo.png',
  tagline: 'Built from the ground up.',
};

export const NAV = [
  { label: 'Home', href: '/' },
  { label: 'Products', href: '/products' },
  { label: 'About', href: '/about' },
  { label: 'Installation', href: '/installation' },
  { label: 'Projects', href: '/projects' },
  { label: 'Contact', href: '/contact' },
];

export const HERO_IMAGES = {
  // primary: residential lawn beside a light beige walkway with modern
  //   house behind — used on the Home hero.
  // secondary: lush lawn next to rattan garden furniture — used on the
  //   About hero. Both supplied by the client (Feb 2026).
  primary: '/heroes/home-hero-walkway.jpg',
  secondary: '/hero/hero-lifestyle-lawn.jpg',
  tertiary: 'https://images.pexels.com/photos/9485805/pexels-photo-9485805.jpeg?auto=compress&cs=tinysrgb&w=2400',
  villa: 'https://images.pexels.com/photos/8143668/pexels-photo-8143668.jpeg?auto=compress&cs=tinysrgb&w=2400',
  villa2: 'https://images.pexels.com/photos/8143683/pexels-photo-8143683.jpeg?auto=compress&cs=tinysrgb&w=2400',
  dusk: '/heroes/home-hero-walkway.jpg',
  aerial: '/hero/hero-lifestyle-lawn.jpg',
  aerial2: '/hero/hero-lifestyle-lawn.jpg',
  dew: 'https://images.pexels.com/photos/1108572/pexels-photo-1108572.jpeg?auto=compress&cs=tinysrgb&w=2000',
  texture: 'https://images.pexels.com/photos/36454802/pexels-photo-36454802.jpeg?auto=compress&cs=tinysrgb&w=1600',
};

export const LIFESTYLE = {
  garden1: 'https://images.pexels.com/photos/259600/pexels-photo-259600.jpeg?auto=compress&cs=tinysrgb&w=2000',
  garden2: 'https://images.pexels.com/photos/12220735/pexels-photo-12220735.jpeg?auto=compress&cs=tinysrgb&w=2000',
  garden3: 'https://images.pexels.com/photos/7283/garden.jpg?auto=compress&cs=tinysrgb&w=2000',
  kids: 'https://images.pexels.com/photos/259600/pexels-photo-259600.jpeg?auto=compress&cs=tinysrgb&w=2000',
  dog: 'https://images.pexels.com/photos/8143668/pexels-photo-8143668.jpeg?auto=compress&cs=tinysrgb&w=2000',
  family: 'https://images.pexels.com/photos/259600/pexels-photo-259600.jpeg?auto=compress&cs=tinysrgb&w=2000',
  install: '/products/supreme.jpg',
};

export const PRODUCTS = [
  {
    slug: 'supreme-lawn',
    name: 'Supreme Lawn',
    pile: '45mm',
    tagline: 'Our most luxurious, longest pile lawn.',
    image: '/products/supreme.jpg',
    carousel: '/products/supreme-install.jpg',
    badge: 'Luxuriously Soft',
    tags: ['Child Friendly', '10-Year Guarantee'],
    description: 'A 45mm C-shaped multi-directional yarn pile delivers a longer, lush lawn appearance while remaining neat and tidy. A straight and curled fibre blend in a two-tone green creates a natural, vibrant lawn that looks great in any setting.',
    bullets: [
      '45mm C-shaped yarn for a fuller, more luxurious lawn',
      'Realistic blend of straight and curled fibres',
      'Enjoy a beautiful lawn with minimal effort',
      'Built to last, season after season',
      'UV-stabilised with a 10-year guarantee for total peace of mind',
    ],
  },
  {
    slug: 'prestige-lawn',
    name: 'Prestige Lawn',
    pile: '40mm',
    tagline: 'A full, premium lawn look with soft, dense fibres.',
    image: '/products/prestige.jpg',
    carousel: '/products/prestige-install.jpg',
    badge: 'Premium',
    tags: ['Child Friendly'],
    description: '40mm pile height for a full, premium lawn look. Soft, dense fibres provide a natural feel underfoot with a multi-tone green blend that enhances realism.',
    bullets: [
      '40mm pile height for a full, premium lawn look',
      'Soft, dense fibres provide a natural feel underfoot',
      'Multi-tone green blend enhances realistic grass appearance',
      'Low maintenance with no mowing, watering or feeding needed',
      'UV-resistant with long-lasting outdoor durability',
    ],
  },
  {
    slug: 'comfort-lawn',
    name: 'Comfort Lawn',
    pile: '38mm',
    tagline: 'A soft, cushioned feel with lush, dense fibres.',
    image: '/products/comfort.jpg',
    carousel: '/products/comfort-install.jpg',
    badge: 'Utility',
    tags: ['Child Friendly', 'Pet Friendly'],
    description: '38mm pile height with a soft, cushioned feel underfoot. A dense construction creates a lush, natural lawn appearance with a multi-tone green colour blend.',
    bullets: [
      '38mm pile height with a soft, cushioned feel underfoot',
      'Dense construction for a lush, natural lawn appearance',
      'Multi-tone green colour blend for realistic depth',
      'Low maintenance with no mowing, watering or fertilising required',
      'UV-resistant with long-lasting outdoor durability',
    ],
  },
  {
    slug: 'pet-lawn',
    name: 'Pet Lawn',
    pile: '30mm',
    tagline: 'Engineered for pets with antibacterial technology.',
    image: '/products/pet.jpg',
    carousel: '/products/pet-install.jpg',
    badge: 'Utility',
    tags: ['Pet Friendly', 'Child Friendly', 'Recyclable'],
    description: 'Specifically designed for pets with antibacterial technology and an enhanced porous backing for 5x better drainage and hygiene. 30mm pile blends straight and curled fibres for a natural look and durability.',
    bullets: [
      'Engineered for pets with advanced antibacterial protection',
      'Natural look with lasting performance — straight & curled fibres',
      'Built for bounce — durable C and diamond-shaped yarns',
      'Colour that stays — UV-resistant with a 10-year guarantee',
      '5x better drainage than standard artificial grass',
    ],
  },
  {
    slug: 'active-lawn',
    name: 'Active Lawn',
    pile: '30mm',
    tagline: 'Built for high-traffic, active gardens.',
    image: '/products/active.jpg',
    carousel: '/products/active-install.jpg',
    badge: 'Sport Friendly',
    tags: ['Pet Friendly', 'Child Friendly', 'Sport'],
    description: '30mm pile height designed for durability and everyday use. Strong, dense fibres for high traffic areas and active gardens with a realistic dual-tone colour blend.',
    bullets: [
      '30mm pile height designed for durability and everyday use',
      'Strong, dense fibres for high traffic areas and active gardens',
      'Realistic dual-tone colour blend for a natural lawn appearance',
      'Low maintenance with no mowing, watering or fertilising needed',
      'UV-resistant with a long-lasting finish for outdoor conditions',
    ],
  },
  {
    slug: 'natural-lawn',
    name: 'Natural Lawn',
    pile: '30mm',
    tagline: 'Budget-friendly artificial grass without compromise.',
    image: '/products/natural.jpg',
    carousel: '/products/natural-install.jpg',
    badge: 'Economical',
    tags: ['Pet Friendly', 'Child Friendly'],
    description: 'Budget-friendly artificial grass ideal for cost-effective garden projects. A 30mm pile delivers a neat, natural-looking finish with a realistic blend of straight and curled fibres.',
    bullets: [
      'Budget-friendly artificial grass for cost-effective projects',
      '30mm pile height for a neat, natural-looking finish',
      'Realistic blend of straight and curled fibres with multi-tone colour mix',
      'Low-maintenance surface — no mowing or watering required',
      'UV-resistant with a 6-year guarantee for lasting performance',
    ],
  },
];

// Gallery showcase — neutral, product-focused (no fabricated locations).
// Real client work lives in PROJECTS_DATA below, sourced from the user.
export const GALLERY = [
  { img: 'https://images.unsplash.com/photo-1758612853656-def5033bccb5?auto=format&fit=crop&w=2000&q=85', caption: 'Prestige Lawn — Family Garden', tag: '40mm Prestige' },
  { img: 'https://images.unsplash.com/photo-1759256243437-9c8f7238c42b?auto=format&fit=crop&w=2000&q=85', caption: 'Comfort Lawn — Hospitality Terrace', tag: '38mm Comfort' },
  { img: 'https://images.unsplash.com/photo-1760643451158-d848ba9e9b1d?auto=format&fit=crop&w=2000&q=85', caption: 'Supreme Lawn — Roof Garden', tag: '45mm Supreme' },
  { img: 'https://images.unsplash.com/photo-1694717192079-1d7deb9b51a1?auto=format&fit=crop&w=2000&q=85', caption: 'Supreme Lawn — Country Estate', tag: '45mm Supreme' },
  { img: 'https://images.pexels.com/photos/8143668/pexels-photo-8143668.jpeg?auto=compress&cs=tinysrgb&w=2000', caption: 'Prestige Lawn — Front Garden', tag: '40mm Prestige' },
  { img: 'https://images.unsplash.com/photo-1681225692736-da34da4c610c?auto=format&fit=crop&w=2000&q=85', caption: 'Comfort Lawn — Pool Garden', tag: '38mm Comfort' },
  { img: 'https://images.pexels.com/photos/12220735/pexels-photo-12220735.jpeg?auto=compress&cs=tinysrgb&w=2000', caption: 'Pet Lawn — Pet Run & Patio', tag: '30mm Pet' },
];

// Product card "feature icons" — visual tag chips that appear on the curved overlay card
export const PRODUCT_FEATURE_ICONS = {
  'Pet Friendly': 'paw',
  'Child Friendly': 'baby',
  'Sport': 'football',
  'Sport Friendly': 'football',
  'Recyclable': 'recycle',
  'Premium': 'crown',
  'Utility': 'wrench',
  'Pro Sport': 'trophy',
  'Economical': 'pound',
  'Luxuriously Soft': 'sparkles',
};

export const FEATURES = [
  { title: 'Civil-Engineering Heritage', body: 'Built from the ground up by Guardian Builders Ltd — decades of groundworks expertise underpin every install.', icon: 'wrench' },
  { title: 'Tailored to Your Garden', body: 'Free site survey and honest advice. Every project specified around your light, drainage and intended use.', icon: 'leaf' },
  { title: 'Engineered Foundations', body: 'Free-draining sub-base, weed-suppressing membrane and calibrated falls — the work below decides lifespan.', icon: 'shield' },
  { title: 'Premium European Products', body: 'Hand-selected, UV-stabilised yarns from established European manufacturers — only what we’d put in our own gardens.', icon: 'leaf' },
  { title: 'SUDS-Compliant & Recyclable', body: 'Sustainable drainage principles and fully recyclable lawns — environmentally responsible by design.', icon: 'droplet' },
  { title: '10-Year Guarantee', body: 'A 10-year product guarantee plus a 24-month groundworks guarantee — proper peace of mind.', icon: 'shield' },
];

export const STEPS_HOME = [
  { n: '01', title: 'Free Quote', body: 'Tell us about your project. We respond within 24 hours with honest advice.' },
  { n: '02', title: 'Site Survey', body: 'A specialist visits your garden — usually within a week. Takes around an hour.' },
  { n: '03', title: 'Professional Installation', body: 'Our in-house teams transform your space, leaving it ready to enjoy.' },
];

export const INSTALL_STEPS = [
  { n: '01', title: 'Site Preparation & Oversite Reduce Dig', body: 'Careful removal of existing grass and root material. Oversite reduce dig to suit project requirements — 50mm is typical, up to 150mm where enhanced drainage is needed.' },
  { n: '02', title: 'Engineered Free-Draining Foundation', body: "If drainage issues are identified during our site survey, a 100mm compacted Type 3 aggregate formation layer is installed — this is free-draining material that forms a structural foundation where groundwater needs additional management to our standard install's granite sub-base." },
  { n: '03', title: 'Standard Free-Draining Subbase Layer', body: 'Free-draining 10mm–1mm compacted crushed granite, 50mm deep and precision-screeded for a glass-smooth, stable surface that drains freely on every install.' },
  { n: '04', title: 'Weed Protection', body: 'High-quality woven geotextile membrane installed for long-term weed suppression and installation stability.' },
  { n: '05', title: 'Premium Grass Installation', body: 'Hand-cut to exact measurements. Joins use 300mm bespoke jointing tape and specialist adhesive for discreet seams.' },
  { n: '06', title: 'Securing & Finishing', body: 'Fixed with 6-inch galvanised steel pins around the perimeter. Kiln-dried sand infill weights and supports the fibres.' },
];

export const PROJECTS_DATA = [
  {
    slug: 'supreme-south-london',
    title: 'Supreme Lawn — South West London',
    product: 'Supreme 45mm',
    sector: 'residential',
    location: 'South West London',
    duration: '1 Day',
    summary: '45mm Supreme Lawn installed to a small back garden in South West London. With no side access, our team laid protection throughout the client’s property, removed all waste in buckets and imported sub-base material in bags. Even though the client was a keen gardener, they had let the lawn become overgrown due to the access issues every time they needed it mowing — they won’t have that problem anymore. Completed using our standard install process as the garden was free-draining, in a single day by our hard-working professional team.',
    before: '/projects/supreme-before.jpg',
    after: '/projects/supreme-after.jpg',
  },
  {
    slug: 'active-nursery-gravesend',
    title: 'Active Lawn — Nursery Grounds, Gravesend',
    product: 'Active 30mm',
    sector: 'education',
    location: 'Gravesend, Kent',
    duration: '2 Weeks',
    summary: '30mm Active Lawn installed to a nursery in Gravesend, Kent. Our client had moved the nursery to a bigger location due to an upturn in business. We were brought in by the principal contractor completing the internal works to complete close-board fencing, EPDM rubber works and several large areas of artificial grass all-weather play areas in our 30mm Active Lawn. This project took 2 weeks to complete and made an incredible transformation to what were previously tired-looking grounds around the new location.',
    afterOnly: true,
    before: '/projects/active-nursery-1.jpg',
    after: '/projects/active-nursery-1.jpg',
  },
  {
    slug: 'active-nursery-gravesend-play',
    title: 'Active Lawn — Nursery Play Area, Gravesend',
    product: 'Active 30mm',
    sector: 'education',
    location: 'Gravesend, Kent',
    duration: '2 Weeks',
    summary: 'A second view of the same Gravesend nursery transformation — this shot captures the close-board fencing and EPDM rubber play-zones working alongside our 30mm Active Lawn. Engineered for high-traffic children\u2019s play, the surface holds its colour through heavy daily use and drains freely after rain.',
    afterOnly: true,
    before: '/projects/active-nursery-2.jpg',
    after: '/projects/active-nursery-2.jpg',
    aliasOf: 'active-nursery-gravesend',
  },
  {
    slug: 'active-school-isle-of-grain',
    title: 'Active Lawn — School Playground, Isle of Grain',
    product: 'Active 30mm',
    sector: 'education',
    location: 'Isle of Grain, Kent',
    duration: '1 Week',
    summary: '30mm Active Lawn installed to a school playground on the Isle of Grain in Kent. For this project we installed over tarmac with a 20mm shock-pad underlay. On this occasion we also installed the sensory playground equipment and fencing as a turnkey project for the client — totally transforming a previously drab and shaded area of the playground. Completed in 1 week by our hard-working professional install team.',
    afterOnly: true,
    before: '/projects/active-school-1.jpg',
    after: '/projects/active-school-2.jpg',
  },
  {
    slug: 'comfort-gravesend',
    title: 'Comfort Lawn — Slabs, Sleepers & Lawn, Gravesend',
    product: 'Comfort 38mm',
    sector: 'residential',
    location: 'Gravesend, Kent',
    duration: '1 Week',
    summary: '38mm Comfort Lawn installed to a back garden in Gravesend, Kent. This was a garden makeover project — we installed porcelain tiles, drainage and sleeper planters. To add the finishing touch we completed our standard install process for our Comfort Lawn, as the garden was free-draining. A new-build property with poor soil meant the client couldn’t keep a nice lawn for their children to enjoy. Completed in a week by our hard-working professional install team — what a difference.',
    before: '/projects/comfort-before.jpg',
    after: '/projects/comfort-after.jpg',
  },
  {
    slug: 'natural-strood',
    title: 'Natural Lawn — Front Garden, Strood',
    product: 'Natural 30mm',
    sector: 'residential',
    location: 'Strood, Kent',
    duration: '1 Day',
    summary: '30mm Natural Lawn installed to a front garden in Strood, Kent to give more kerbside appeal. This client was a keen gardener but with hose-pipe bans could not keep the front lawn looking lush in the summer months. We completed our standard install process, as the garden was free-draining, with the addition of a composite rail concreted in place at the top of the bank which the Natural Lawn was secured to. This ensured the artificial lawn did not slide down the bank over time. What a transformation — and all completed in a day by our hard-working professional install teams.',
    before: '/projects/natural-before.jpg',
    after: '/projects/natural-after.jpg',
  },
  {
    slug: 'pet-rochester',
    title: 'Pet Lawn — Front Garden, Rochester',
    product: 'Pet 30mm',
    sector: 'residential',
    location: 'Rochester, Kent',
    duration: '1 Day',
    summary: '30mm Pet Lawn installed to a front garden in Rochester, Kent. On this occasion our client’s dog was killing the grass when using it as a toilet area. We completed our standard install process, as the garden was free-draining. Specially developed for pets, this product utilises antibacterial technology and has 5× better drainage than normal artificial products — which helps keep away the smells animals leave behind. No more patches in the lawn, and all completed in a day by our hard-working professional install teams.',
    before: '/projects/pet-before.jpg',
    after: '/projects/pet-after.jpg',
  },
  {
    slug: 'prestige-maidstone',
    title: 'Prestige Lawn — Front Garden, Maidstone',
    product: 'Prestige 40mm',
    sector: 'residential',
    location: 'Maidstone, Kent',
    duration: '2 Days',
    summary: '40mm Prestige Lawn installed to a front garden in Maidstone, Kent to amplify the kerbside appeal of this well-kept front garden. This client had issues keeping a nice-looking front lawn after another contractor completed their driveway paving. We completed our standard install process, as the garden was free-draining, with the addition of a composite rail concreted in place at the top of the bank which the Prestige Lawn was secured to. This ensured the artificial lawn did not slide down the bank over time. Now the entire front garden looks high end — completed in 2 days by our hard-working professional install teams.',
    before: '/projects/prestige-before.jpg',
    after: '/projects/prestige-after.jpg',
  },
];

// Service sectors — 4 boxes at bottom of homepage.  All four images are
// REAL Guardian installs (with one stock 3G/4G pitch for Sports until we
// have an in-house photo).  Filenames are SEO-friendly so Google Image
// Search can read context from the URL too.
export const SECTORS = [
  {
    slug: 'residential',
    title: 'Residential',
    body: 'Front and back gardens, roof terraces and balconies. From compact London courtyards to country estates.',
    image: '/sectors/residential-lawn-luxury-home.webp',
    alt: 'Luxury residential artificial lawn install — Guardian Artificial Lawns',
    objectPosition: 'center 35%',
    examples: ['Family Lawns', 'Front Gardens', 'Balconies & Terraces'],
  },
  {
    slug: 'sports',
    title: 'Sports',
    body: 'Cricket nets, putting greens, tennis tramlines and 5-a-side. Engineered shock-pad sub-bases for performance.',
    image: '/sectors/sports-football-artificial-pitch.webp',
    alt: 'Football artificial pitch — performance turf install by Guardian',
    examples: ['Putting Greens', 'Cricket Surfaces', '5-A-Side Pitches'],
  },
  {
    slug: 'education',
    title: 'Education',
    body: 'Playgrounds, EYFS spaces and school sports areas. Compliant with critical-fall-height standards.',
    image: '/sectors/education-playground-artificial-grass.webp',
    alt: 'Education playground artificial grass — Guardian EYFS install',
    examples: ['EYFS Play Areas', 'Sensory Playgrounds', 'School Pitches'],
  },
  {
    slug: 'commercial',
    title: 'Commercial',
    body: 'Show homes, hotel grounds, hospitality terraces and corporate landscaping — turnkey, on-time, on-budget.',
    image: '/sectors/commercial-courtyard-artificial-lawn.webp',
    alt: 'Commercial courtyard artificial lawn — Guardian install',
    examples: ['Show Homes', 'Hospitality Grounds', 'Corporate Landscaping'],
  },
];

export const STATS = [
  { n: '20+', label: 'Years of Specialist Installation' },
  { n: '30+', label: 'Years Supply-Chain Heritage' },
  { n: '10', label: 'Year Product Guarantee' },
  { n: '24', label: 'Month Groundworks Guarantee' },
];

// Awards / certifications — REMOVED. The site previously displayed fabricated
// awards (BALI, Houzz, Marshalls, CHAS) that had no basis in any source
// material. Restore this array with verified accolades supplied by the client.
export const AWARDS = [];

// Press / "As featured in" — REMOVED for the same reason. Restore with
// verified publication mentions when client supplies them.
export const PRESS = [];

// Material samples for texture grid
export const MATERIALS = [
  { name: 'Supreme 45mm',  pile: '45mm', tone: 'Two-tone Summer',  img: '/products/supreme.jpg' },
  { name: 'Prestige 40mm', pile: '40mm', tone: 'Multi-tone Field', img: '/products/prestige.jpg' },
  { name: 'Comfort 38mm',  pile: '38mm', tone: 'Soft Multi-tone',  img: '/products/comfort.jpg' },
  { name: 'Pet 30mm',      pile: '30mm', tone: 'Antibacterial',    img: '/products/pet.jpg' },
  { name: 'Active 30mm',   pile: '30mm', tone: 'Dual-tone',        img: '/products/active.jpg' },
  { name: 'Natural 30mm',  pile: '30mm', tone: 'Natural Blend',    img: '/products/natural.jpg' },
];

// (Awards array removed — see comment above where PRESS/AWARDS are now empty.)

// Process highlights — depth + drainage data points
export const PROCESS_LAYERS = [
  { depth: '0\u2013150mm', label: 'Excavation', body: 'Site reduced to engineered depth, removing organic material and roots.' },
  { depth: '100mm',     label: 'Type 3 Aggregate', body: 'Free-draining structural foundation, compacted in lifts.' },
  { depth: '50mm',      label: '10\u20131mm Granite Sub-Base', body: 'Precision-screeded crushed granite for a glass-smooth surface.' },
  { depth: '0mm',       label: 'Geotextile Membrane', body: 'Long-term weed suppression and installation stability.' },
  { depth: '+0\u201345mm', label: 'Premium Lawn', body: 'Hand-cut, taped, glued, pinned, and infilled by our in-house teams.' },
];

export const TRUST = [
  'Premium European manufactured product',
  '10-year product guarantee',
  'Fully recyclable',
  'SUDS compliant drainage principles',
  'Installed by experienced in-house specialists',
  '24-month groundworks guarantee',
];


// Common pre-quote questions — answered from the client brief (no
// fabricated stats / claims). Displayed on the Contact page above the
// enquiry form so visitors can resolve quick objections before they
// bother filling in the contact form.
export const FAQS = [
  {
    q: 'How long does a Guardian artificial lawn last?',
    a: 'Our premium European-manufactured ranges carry a 10-year product guarantee. With our groundworks-grade base build, most installs comfortably exceed that — many of our earliest lawns from 20+ years ago are still going strong.',
  },
  {
    q: 'How much does an artificial lawn cost?',
    a: 'Every garden is different — pile choice, access, sub-base depth and groundworks all move the number. We do a free, no-obligation site survey and give you a detailed written quote within 48 hours, so there is no guessing.',
  },
  {
    q: 'Will water drain properly through it?',
    a: 'Yes. Every Guardian install is built to SUDS-compliant drainage principles: a free-draining 50mm crushed-granite sub-base on every site, plus a 100mm Type 3 aggregate drainage layer added where the project requires it. Calibrated falls and free-draining materials mean heavy rain runs through, not over.',
  },
  {
    q: 'Is it safe for children and pets?',
    a: 'All our ranges are child-safe and pet-friendly. The Pet range adds antibacterial yarn technology and enhanced drainage; Comfort and Supreme give the softest underfoot feel for play areas.',
  },
  {
    q: 'How long does an installation take?',
    a: 'A typical residential install is 3–5 working days from arrival on site — site preparation, full sub-base, membrane, lawn fit, joins, edging and infill. Larger or split-level projects are scoped at survey.',
  },
  {
    q: 'What areas do you cover?',
    a: 'Greater London, Kent, Surrey and Essex from our Medway base. Commercial and sports projects further afield are handled case-by-case — get in touch and we will let you know.',
  },
  {
    q: 'Do you only fit your own product?',
    a: 'Yes. We install every range we sell with our own in-house teams — no sub-contracted fitters. That is what lets us back the work with both a 10-year product guarantee and a 24-month groundworks guarantee.',
  },
];
